import { render, staticRenderFns } from "./under-way-table.vue?vue&type=template&id=4a8c3ec0&scoped=true&"
import script from "./under-way-table.vue?vue&type=script&lang=js&"
export * from "./under-way-table.vue?vue&type=script&lang=js&"
import style0 from "./under-way-table.vue?vue&type=style&index=0&id=4a8c3ec0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8c3ec0",
  null
  
)

export default component.exports